// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperImages-cls1_ngt","cls2":"PaperImages-cls2_I3f PaperImages-cls1_ngt"};